<template>
  <div class="pagination flex center gaps">
    <!-- スペース埋め -->
    <div class="box grow" />

    <!-- ページ移動（前へ） -->
    <div class="box">
      <el-button
        :disabled="currentPage === 1 || !total"
        @click="prevPage"
      >
        <i class="el-icon-arrow-left" />
        前のページ
      </el-button>
    </div>

    <!-- ページャ -->
    <div class="box">
      <el-pagination
        background
        layout="pager"
        :total="total"
        :page-size="pageSize"
        :current-page="localCurrentPage"
        @current-change="changePage"
      />
    </div>

    <!-- ページ移動（次へ） -->
    <div class="box">
      <el-button
        :disabled="currentPage === totalPage || !total"
        @click="nextPage"
      >
        次のページ
        <i class="el-icon-arrow-right" />
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePagination",
  props: {
    total: Number,
    totalPage: Number,
    currentPage: Number,
    pageSize: Number,
  },
  data () {
    return {
    };
  },
  computed: {
    localCurrentPage: {
      get () {
        return this.currentPage;
      },
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    changePage (value) {
      this.update(value);
    },

    prevPage () {
      const value = this.localCurrentPage - 1;

      this.update(value);
    },

    nextPage () {
      const value = this.localCurrentPage + 1;

      this.update(value);
    },

    update (value) {
      this.$emit("update:currentPage", value);
      this.$emit("onChangeCurrentPage");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.pagination {
  padding: 12px;

  .el-icon-arrow-left {
    margin-right: 8px;
    transform: translateX(-6px);
  }

  .el-icon-arrow-right {
    margin-left: 8px;
    transform: translateX(6px);
  }

  .el-button.is-disabled {
    border-color: $default-border-color-light;
  }
}

::v-deep {
  .el-pagination {
    padding: 2px 0;
  }
  .el-pagination.is-background .el-pager li {
    height: 36px;
    min-width: 36px;
    margin-right: 5px;
    background-color: $background-gray-base !important;
    line-height: 36px;
  }

  .el-pagination.is-background .el-pager li.active {
    background-color: $--color-primary !important;
  }
}
</style>
